import _ from 'underscore';
import React, { useEffect, useState } from 'react';
import { useResponsiveSize } from '@bingads-webui-react/with-responsive-size';
import { CollapsibleSidePanel } from '@bingads-webui-fluent-component/collapsible-side-panel';
import { useWizardService, getCurrentStepId } from '@bingads-webui-react/wizard-core';

interface SummaryPanelProps {
  config?: Array<{
    id: string;
    title?: string;
    ariaLabel?: string;
    toolTipText?: string;
    view?: () => React.ReactNode | string;
  }>;
}

export const SummaryPanel: React.FC<SummaryPanelProps> = ({ config }) => {
  const { state } = useWizardService();
  const currentStepId = getCurrentStepId(state);
  const summaryConfig = _.find(config, (c) => c.id === currentStepId);
  const {
    title, ariaLabel, toolTipText, view: ContentView,
  } = summaryConfig || {};
  const displayMode = useResponsiveSize();

  const collapsedMode = ['l', 'xl'].includes(displayMode);

  const [isCollapsed, setIsCollapsed] = useState(false);

  useEffect(() => {
    setIsCollapsed(collapsedMode);
  }, [collapsedMode]);

  if (!_.isFunction(ContentView)) {
    return null;
  }

  return (
    <CollapsibleSidePanel title={title} ariaLabel={ariaLabel} toolTipText={toolTipText} isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed}>
      <ContentView />
    </CollapsibleSidePanel>
  );
};

SummaryPanel.defaultProps = {
  config: [],
};
